import React from 'react';
import './Loader.css';

const Loader = () => {
	return (
		<div className="loaderContainer">
			<svg id="ravi" width="408" height="210" viewBox="0 0 408 210" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M24.4147 14.7659L4 40.2977H51.2089V196.041L86.9346 160.297H112.453L67.7958 207.531H102.884L146.468 161.584H233.665V197.318L347.22 67.1343V192.852L372.74 161.584V37.7448L404 2H370.188L259.183 129.659V5.19147L136.057 135.404H112.453L228.561 14.7659H24.4147ZM168.593 40.2977L75.45 135.53V40.2977H168.593ZM233.665 136.042V69.6592L170.696 136.042H233.665Z"
					stroke="#00FFFC"
					strokeWidth="3"
				/>
			</svg>
		</div>
	);
};

export default Loader;
